import React from 'react';
import { Row, Col } from 'antd';
import PlaceForm from '../forms/PlaceForm';
import SignerForm from '../forms/SignerForm';
import WhatsappButton from '../WhatsappButton';
import PropTypes from 'prop-types';

const SignersStep = ({ form }) => {
  return (
    <React.Fragment>
      <Row justify="center">
        <Col xs={24} md={22} lg={18} xl={14}>
          <PlaceForm />
          <SignerForm id="lessor" formName="Arrendador" description="Ingresa los datos del propietario del inmueble" form={form} />
          <SignerForm id="lessee" formName="Arrendatario" description="Ingresa los datos de quien usará el inmueble" form={form} />
          <SignerForm id="codebtor" formName="Codeudor" description="Aval del arrendador" form={form} />
        </Col>
        <WhatsappButton />
      </Row>
    </React.Fragment>
  );
};

SignersStep.propTypes = {
  form: PropTypes.object.isRequired,
};

export default SignersStep;